import React from 'react'
import Alert from '../../../../Mantine/AlertCard'

export default function Alerta() {
  const message = (
    <div>
      <b>Cliente VIVO 2G</b> não será mais possível realizar pedidos de
      reposições de linhas 2G. Novas ativações e pedidos de reposição de linhas
      serão apenas com a tecnologia 4G.
    </div>
  )

  return <Alert type="warning" message={message} />
}
